import {
	ChangeSet,
	ChangeSetEntityChangeType,
	EntityType,
	GlobalEventNames,
	IGlobalEventTransfer,
} from '@elyx-code/project-logic-tree';
import { IConnectionDrawingOptions } from '..';
import {
	ProjectState,
	ActionDescriptorState,
	GlobalEventState,
	createStateFromTypeAndSubscribe,
} from '@elyx-code/project-logic-tree';
import { createSemanticId } from '@elyx-code/project-logic-tree';
import { resolveEntityName } from '@elyx-code/project-logic-tree';

export function createGlobalEventFromActionDescriptor(
	from: ActionDescriptorState,
	_connectionOptions: IConnectionDrawingOptions,
	project: ProjectState,
	changeSet: ChangeSet
): GlobalEventState {
	// Create a new function-declaration that implements the abstract entity
	const newInstance = from.implementAsGlobalEvent(
		changeSet,
		project,
	) as GlobalEventState;

	changeSet.add(newInstance, ChangeSetEntityChangeType.Added);

	return newInstance;
}
